import { useHistory } from 'react-router-dom';
import {
	AppDrawer,
	AppDrawerToolbar,
	AppDrawerToolbarButtonAiAssistant,
	StickyAppDrawerContent,
} from '../../components-v2/Drawer/AppDrawer';
import { EditAutomationTemplate } from '../../containers/EditAutomationTemplate';
import { DefaultUniversalAssistantChat } from '../../containers/templates/AssistantChat';

export const EditAutomationTemplateWithAppDrawer = () => {
	const history = useHistory();

	return (
		<>
			<EditAutomationTemplate
				onAutomationDeleted={() => history.replace('/automations')}
				onAutomationPublished={() => history.push('/automations')}
				onAutomationDisabled={() => history.push('/automations')}
			/>
			<AppDrawer>
				<StickyAppDrawerContent value='ai-assistant'>
					<DefaultUniversalAssistantChat />
				</StickyAppDrawerContent>
				<AppDrawerToolbar>
					<AppDrawerToolbarButtonAiAssistant value='ai-assistant' />
				</AppDrawerToolbar>
			</AppDrawer>
		</>
	);
};
